export const ARTICLES = {
  COMMISSION_SPLITS: 11,
  COMMISSION_LOCK: 18,
  COMMISSION_FEATURES: 17,
  PRODUCTION_CREDIT: 84,
  SWITCH_LOGIN: 28,
  ROUND_ROBIN: 64
};
